(function () {
  if (window.LaurelDeliveryCountdown) return;
  window.LaurelDeliveryCountdown = true;

  var KEYS = ['selangor', 'johor', 'penang', 'ipoh', 'seremban'];

  function klParts(tz) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz || 'Asia/Kuala_Lumpur',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach(function (p) {
        if (p.type !== 'literal') parts[p.type] = p.value;
      });
    return parts;
  }

  function parseSchedule(raw) {
    return String(raw || '')
      .split(/\r?\n/)
      .map(function (line) {
        line = line.trim();
        if (!line) return null;
        var i = line.indexOf('|');
        if (i < 0) return null;
        var bits = line.slice(0, i).trim().split(':');
        var h = parseInt(bits[0], 10);
        var m = parseInt(bits[1], 10) || 0;
        if (isNaN(h) || h < 0 || h > 23) return null;
        return { min: h * 60 + m, text: line.slice(i + 1).trim() };
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.min - b.min;
      });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function locationKey() {
    var el = document.getElementById('selected-value-variant');
    var text = (el ? el.textContent : '') || '';
    text = text.toLowerCase();
    for (var i = 0; i < KEYS.length; i++) {
      if (text.indexOf(KEYS[i]) !== -1) return KEYS[i];
    }
    return 'default';
  }

  function scheduleFor(root) {
    var key = locationKey();
    var raw = root.getAttribute('data-schedule-' + key);
    if (!raw) raw = root.getAttribute('data-schedule-default');
    return parseSchedule(raw);
  }

  function formatRemain(remainSec) {
    var h = Math.floor(remainSec / 3600);
    var m = Math.floor((remainSec % 3600) / 60);
    var s = remainSec % 60;
    return h + 'h ' + m + 'm ' + s + 's';
  }

  function renderLine(el, text, remainSec) {
    var idx = text.indexOf('[timer]');
    if (idx === -1) {
      el.textContent = text;
      return;
    }
    el.innerHTML =
      escapeHtml(text.slice(0, idx)) +
      '<span class="ps-delivery-countdown__timer">' +
      escapeHtml(formatRemain(remainSec)) +
      '</span>' +
      escapeHtml(text.slice(idx + 7));
  }

  function tick(root) {
    var line = root.querySelector('[data-ps-line]');
    var rows = scheduleFor(root);
    if (!line || !rows.length) return;
    var parts = klParts(root.getAttribute('data-tz'));
    var nowMin = parseInt(parts.hour, 10) * 60 + (parseInt(parts.minute, 10) || 0);
    var nowSec = nowMin * 60 + (parseInt(parts.second, 10) || 0);
    var activeIdx = 0;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].min * 60 <= nowSec) activeIdx = i;
    }
    var active = rows[activeIdx];
    var next = rows[(activeIdx + 1) % rows.length];
    var nextSec = next.min * 60;
    if (nextSec <= nowSec) nextSec += 24 * 3600;
    var remain = Math.max(0, nextSec - nowSec);
    renderLine(line, active.text, remain);
  }

  function tickAll() {
    document.querySelectorAll('[data-ps-delivery]').forEach(tick);
  }

  function start() {
    tickAll();
    setInterval(tickAll, 1000);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, tickAll);
      subscribe(PUB_SUB_EVENTS.variantChange, tickAll);
    }
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t) return;
      if (t.name === 'options[Location]' || (t.closest && t.closest('fieldset.product-form__input'))) {
        tickAll();
      }
    });

    var loc = document.getElementById('selected-value-variant');
    if (loc && typeof MutationObserver !== 'undefined') {
      new MutationObserver(tickAll).observe(loc, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
